import { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const handleLogout = () => { logout(); navigate('/signin'); };

  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-inner page-container">
        <NavLink to="/" className="navbar-logo">
          <span className="logo-icon">⇄</span>
          <span className="logo-text">SkillSwap</span>
        </NavLink>

        {user && (
          <>
            <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
              <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} end>
                <span className="nav-icon">◎</span> Home
              </NavLink>
              <NavLink to="/profile" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <span className="nav-icon">◉</span> Profile
              </NavLink>
              <NavLink to="/messages" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <span className="nav-icon">◈</span> Messages
              </NavLink>
              <NavLink to="/swaps" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                <span className="nav-icon">⇆</span> Swaps
              </NavLink>
              <button className="nav-link nav-logout" onClick={handleLogout}>
                <span className="nav-icon">→</span> Logout
              </button>
            </div>

            <div className="navbar-right">
              <NavLink to="/profile" className="navbar-avatar-link">
                <div className="avatar" style={{ width: 36, height: 36, fontSize: 13 }}>
                  {user.avatar ? (
                    <img src={user.avatar} alt={user.name} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
                  ) : initials}
                </div>
                <span className="navbar-username hide-mobile">{user.name.split(' ')[0]}</span>
              </NavLink>
              <button
                className={`hamburger ${menuOpen ? 'open' : ''}`}
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
              >
                <span /><span /><span />
              </button>
            </div>
          </>
        )}

        {!user && (
          <div className="navbar-auth">
            <NavLink to="/signin" className="btn btn-ghost btn-sm">Sign In</NavLink>
            <NavLink to="/signup" className="btn btn-primary btn-sm">Sign Up</NavLink>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
